import { theme } from "../../styles/themeSettings.js"

export const IS_MOBILE_CSS_QUERY = `(max-width:${theme?.breakpoints?.tablet - 1}px)`
export const IS_TABLET_CSS_QUERY = `(min-width:${theme?.breakpoints?.tablet}px)`
export const IS_DESKTOP_CSS_QUERY = `(min-width:${theme?.breakpoints?.desktop}px)`
export const IS_LANDSCAPE_CSS_QUERY = `(orientation: landscape)`
export const IS_DESKTOP_FULL_CSS_QUERY = `${IS_DESKTOP_CSS_QUERY} and ${IS_LANDSCAPE_CSS_QUERY}`
